import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import { Link } from "react-router-dom";
import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Competition = () => {
  return (
    <React.Fragment>
      <SEO title="ICSI-OC'2022 | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="ICSI-OC'2022"
        content="For Authors"
        contentTwo="ICSI-OC'2022"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <h2>ICSI Optimization Competition 2022 (ICSI-OC&apos;2022)</h2>
          <br></br>
          <h3>Introduction</h3>
          <div className="Intro-test">

            
          <p align="justify">
            <br></br>
            ICSI-OC&apos;2022 provides dedicated test sets and competitions for
            many researchers on swarm intelligence and heuristic algorithms.
            Researchers can use the provided ICSI-OC&apos;2022 test set to test their algorithm or
            participate in the competition organized by ICSI&apos;2022. For the
            contestants who have performed well in the competition, the
            competition organizing committee will provide generous bonuses. The
            specific ICSI-OC&apos;2022 test sets and competition projects are listed below.
            Detailed documentation and usage are provided for each ICSI-OC&apos;2022 test set. The
            code for the ICSI-OC&apos;2022 test set is also available on this website. Researchers
            participating in the competition should write a paper in accordance
            with the corresponding requirements, and include the information
            required for participating in the competition in the paper.<br/> <br/>

            <strong>
            Notice: The
            deadline for submission of competition papers is May 27, 2022 <br/>
            {/* Participants who submit papers in Chinese please visit <a href="http://iasei.org/icsi2022/competition_zn">http://iasei.org/icsi2022/competition_zn</a> for more information. */}


            </strong>
          </p>
          </div>


          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2 id="competition1">
             ICSI-OC&apos;2022: <em>Competition on Single Objective Bounded
            Optimization Problems</em> 
          </h2>
          <br/>
          <h3>Overview</h3>
          <p>
            Since optimization problems are widely used in real-world
            applications, it has always been one of the hot topics in research.
            With the popularity of machine learning and deep learning, how to
            efficiently and accurately solve optimization problems has become an
            urgent problem that needs to be addressed. Among them, the
            single-objective bounded optimization problem is one of the basic
            types of all optimization problems. Due to the complexity of modern
            optimization problems, the optimization of some complex functions is
            relatively difficult. Decades ago, the emergence of stochastic
            search algorithms such as evolutionary algorithms and swarm
            intelligence algorithms makes it possible to find the global optimal
            solutions of some complex functions. In order to test the
            performance of numerous evolutionary algorithms and swarm
            intelligence algorithms, we propose a test set to complete this
            task.
            <br />
            <br />
            This competition is devoted to the evolutionary algorithms and
            swarm intelligence algorithms for solving single-objective bounded
            optimization. We encourage all researchers to test their algorithms
            on the ICSI&apos;2022 test set. This test set includes 10
            black-box test functions which means you do not need to know the
            exact form of these test functions. This form of benchmark functions
            is convenient for researchers to design and improve their
            algorithms, and it is also helpful for improving the generalization
            of the algorithms.
            <br />
            <br />
            The participants are required to send papers and experiment source code to the Organizing Committee. The organizers will present an overall analysis and comparison based on
            these results. We will select the algorithms that perform well and
            give them a certain amount of bonuses. We are encouraging all
            researchers to test their algorithms on this test set and take
            part in our competition.
            






            {/* All
            the code is available on{" "}
            <a href="https://github.com/cil-lab/icsi2022">Github</a>. You could
            check the README file to learn how to use our ICSI&apos;2022 test
            suite. Read this{" "}
            <a href="https://github.com/cil-lab/icsi2022/blob/main/ICSI_2022_Benchmark_functions.pdf">
              PDF
            </a>{" "}
            to understand what information should be submitted in the paper. */}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            {/* Research areas include, but are not limited to, the following topics: */}
            <ul>
              <li>
                Swarm intelligence algorithms: Fireworks algorithm, particle swarm optimization,
                bacterial foraging optimization, grey wolf optimization,
                artificial fish search algorithm, Bees algorithms, etc;
              </li>
              <li>
                Evolutionary algorithms: Genetic Algorithm, differential
                evolution, evolutionary strategies, etc.;
              </li>
              <li>Other related heuristic algorithms.</li>
            </ul>
          </p>
          <p>
          <br/>

              <h3>Source Code</h3>

              We provide python and MATLAB code for our benchmark functions. 
            All codes can be downloaded on this website. You can view the <b>README file</b> to learn how to use our ICSI-OC&apos;2022 test set. 
            <br/>
            Read the PDF file below to learn about the details of the ICSI-OC&apos;2022 test set and parameter setting of the experiment. Some submission formats for papers are also included.<a href="./files/ICSI_2022_Benchmark_functions.pdf">Download PDF</a>
            <br/>
            Click the link to download the ICSI-OC&apos;2022 test set. &nbsp;
            <a href="files/icsi2022.zip">Download ICSI2022 Single Objective Bounded
            Optimizationtest Benchmark.</a>


          </p>
          <p><br/>
              <h3>Criteria and Rewards</h3>
              <br/>
          </p>
          <p>
          All submitted papers and experimental results will be judged by the Organizing Committee using the same criteria. Ranking is mainly based on the average value of the results. We will use the Wilcoxon rank sum test on all experimental results to examine the differences between the different algorithms. The average ranking for each algorithm is then calculated. If the ranking is the same, then the time complexity of the algorithm and the resource occupied are also taken into account. Finally, a ranking of all algorithms is obtained. <br/>
               <br/>
               The top three algorithms will be awarded Gold, Silver and Bronze respectively. The top 10% of the algorithms will receive a hororable prize.
          </p>


          <p>
          <br/>
            <h3>Submission</h3>
            People who participate in our competition need to submit a conference paper to ICSI&apos;2022.
          The paper must include at least the following information.
          <ul>
            <li>
            <strong>Basic Information: </strong>The paper should include introduction to the algorithm, related work and detailed description of the algorithm.

            </li>
            <li>
              <strong>
            Experimental results: &nbsp;
              </strong>
              The experimental part of the paper needs to contain the following content.
              <ul>
                <li>Testing Platform: Python 3.6/MATLAB R2020B.</li>
                <li>
                Computer Configuration Information: i7-11700K @ 3.60GHz CPU and 16.0 GB
RAM, using win 10 OS.
              
                </li>
                <li>Recording Table:&nbsp;Please refer to the PDF file for the form of the table.
                {/* <div className="record-table">
                <table>
                  
    <tr>
        <td>  No.</td>
        <td>Best</td>
        <td>Worst</td>
        <td>Median</td>
        <td>Mean</td>
        <td>Std</td>
    </tr>
    <tr>
        <td> F01</td>
        <td>0.00 E+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F02</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F03</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F04</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F05</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F06</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F07</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F08</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F09</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
    <tr>
        <td> F10</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
        <td>0.00 e+00</td>
    </tr>
</table>
<p align="center">Results for 10D problems</p>
                </div> */}
                The paper needs to show D=10, 20, 50-dimensional problems, a total of three tables. Notice: The results in the table are the error values, i.e.: f(x)-f*(x). The optimal value for the problem is given in the PDF file.
                </li>
              </ul>
            </li>
            <li>
              <strong>
              Parameters: &nbsp;
              </strong>
              People who participate in our competition need to provide:
              <ol>1. Symbols of all parameters and their meanings.</ol>
              <ol>2. Actual parameter values used in the experiment.</ol>

              </li>

          </ul>



          <br/>

            Please follow the ICSI 2022 instruction for authors and submit your
            paper via the ICSI 2022 online submission system.
            <br/>
            Paper submission address: <a href="http://iasei.org/icsi2022/submission">http://iasei.org/icsi2022/submission</a>
            
            <br></br> Please specify
            that your paper is for &nbsp;
            <strong>
             Competition on Single Objective Bounded
              Optimization Problems
            </strong>{" "}
            in your paper. 
            <br></br> Please choose <strong> ICSI-OC&apos;2022 Track </strong>  when you submit your paper in Easychair.
            <br></br> Please package the code source file and send it to : icsi-oc-2022@iasei.org. Please mark your paper title and id.
          </p>

          <div className="space-40"></div>

          <div className="author reg">
          <h3>Result</h3>
          
          <Link
            className="btn btn-primary"
            to={process.env.PUBLIC_URL + "/competition_result"}
          >
           Competition Result
          </Link>

        </div>


          <p>
            <div className="space-40"></div>
            <h3>Contact</h3>
            <br></br>
            <table>
              <tr>
                <td>ICSI-OC Organizing Committee</td>
                <td>icsi-oc-2022@iasei.org</td>
              </tr>
            </table>
          </p>

        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Competition;
